module.exports = __webpack_public_path__ + "img/headerImg.e31f4758.png";